export default {"src":"/_next/static/media/bj.b33efc66.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};